module.exports = __webpack_public_path__ + "static/media/S-8.f22ad56d.mp3";